import React from "react";
import { SkeletonBase } from "@foris/avocado-suite";
import styles from "./groupsRestrictions.module.scss";

const GroupRestrictionsSkeleton = () => {
  return (
    <div className={styles.groupRestrictions}>
      <div className={styles.inheritedRestrictionsSkeleton}>
        <div className={styles.inheritedRestrictionsSkeleton_header}>
          <SkeletonBase width={280} height={24} />
        </div>

        <div className={styles.inheritedRestrictionsSkeleton_content}>
          <div className={styles.skeletonItem}>
            <SkeletonBase width="100%" maxWidth={296} height={16} />
            <SkeletonBase width="100%" maxWidth={296} height={16} />
            <SkeletonBase width="100%" maxWidth={296} height={16} />
          </div>
          <div className={styles.skeletonItem}>
            <SkeletonBase width="100%" maxWidth={296} height={16} />
            <SkeletonBase width="100%" maxWidth={296} height={16} />
            <SkeletonBase width="100%" maxWidth={296} height={16} />
          </div>
        </div>
      </div>

      <div className={styles.groupRestrictions_form}>
        <div className={styles.formHeader}>
          <SkeletonBase width={280} height={24} />
        </div>

        <div className={styles.formSkeletonContent}>
          <div className={styles.skeletonItem}>
            <SkeletonBase width="100%" maxWidth={72} height={16} />
            <SkeletonBase width="100%" maxWidth={72} height={16} />
            <SkeletonBase width="100%" maxWidth={72} height={16} />
            <SkeletonBase width="100%" maxWidth={72} height={16} />
          </div>
          <div className={styles.skeletonItem}>
            <SkeletonBase width="100%" maxWidth={72} height={16} />
            <SkeletonBase width="100%" maxWidth={72} height={16} />
            <SkeletonBase width="100%" maxWidth={72} height={16} />
            <SkeletonBase width="100%" maxWidth={72} height={16} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupRestrictionsSkeleton;
